export const LOAD_USER = 'LOAD_USER';
export const UPDATE_USER_SUCESSFUL = 'UPDATE_USER_SUCESSFUL';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const UPLOAD_USER_PICTURE = 'UPLOAD_USER_PICTURE';
